import styled from 'src/style';
import { mediaQueries } from 'src/style/breakpoints';
import { SectionSubtitle } from '../Typography';
import colors from 'src/style/colors';

export const Price = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  [mediaQueries.phoneOnly]: {
    justifyContent: 'center',
    textAlign: 'center',
  },
});

export const NextSessionDate = styled(SectionSubtitle)({
  color: colors.yellow,
});

export const NextSessionContainer = styled.div({
  [mediaQueries.phoneOnly]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
